var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center my-1"},[_c('div',[_c('clock-icon',{attrs:{"size":_vm.oneline ? '18' : '26'}})],1),(_vm.oneline)?_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.day)+" "+_vm._s(_vm.time))]):_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.day)),_c('br'),_vm._v(_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }